import {
    Component,
    AfterViewInit,
    ElementRef,
    ViewChild,
    Inject,
} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {GlobalService} from "./services/global.service";
import {MessageModel} from "./model/menu.model";
import {CheckboxModel} from "./model/checkbox.model";
import {menuData} from "./components/menu/menu.data";
import {MenuComponent} from "./components/menu/menu.component";
import {MenuDrawerComponent} from "./components/menu-drawer/menu-drawer.component";
import {DOCUMENT} from "@angular/common";
import {StorageNames, StorageService} from "./services/storage.service";
import axios from "axios";
import {ApiClientService} from "./services/apiClient.service";
import {RemoteDataService} from "./services/remoteData.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent implements AfterViewInit {
    width: number;
    menuItems: string[];
    itemsContainerHeight: string = 'auto';
    drawerTextHeight: string = 'auto';
    isLoaderConfigOn: boolean = false;
    
    private allowedOrigin: string;

    public settings: any;
    @ViewChild(MenuComponent) menuComponent: MenuComponent;
    @ViewChild(MenuDrawerComponent) menuDrawerComponent: MenuDrawerComponent;

    constructor(private translate: TranslateService,
                private globalService: GlobalService,
                @Inject(DOCUMENT) private document: Document,
                private storageService: StorageService,
                private apiClient: ApiClientService,
                private remoteDataService: RemoteDataService) {
        
        this.allowedOrigin = new URLSearchParams(window.location.search).get('url') as string;

        this.startupMessages();
    }

    startupMessages() {
        const configRequestValue = this.storageService.getLoaderConfigValue();
        if (configRequestValue) {
            this.isLoaderConfigOn = true;
            window.parent.postMessage({
                action: "loaderConfig",
                requestUrl: configRequestValue
            }, "*");
        } else {

            window.addEventListener("message", this.recieveMessage.bind(this), false);
            window.parent.postMessage({
                action: "activation",
                isLocalStorageEnabled: this.storageService.isLocalStorageSupported
            }, "*");
        }
    }

    ngAfterViewInit() {
    }

    recieveMessage(event) {
        if (event.origin != this.allowedOrigin || !event.data) return;
        let data = event.data;
        this.translate.setDefaultLang('en');
        this.translate.use(data.data?.lang ?? "en");
        switch (data.action) {
            case "activation":
                data.data?.isOnPremise && this.remoteDataService.setIsOnPremise(data.data.isOnPremise);
                data.data?.staticAddress && this.remoteDataService.setStaticAddress(data.data.staticAddress);
                data.data?.url && this.globalService.setSiteUrl(data.data.url);
                data.data?.fullUrl && this.globalService.setFullUrl(data.data.fullUrl);
                data.data?.apiAddress && this.apiClient.setApiAddress(data.data.apiAddress);
                data.data?.validatorFixers && this.remoteDataService.setValidatorFixersAddress(data.data.validatorFixers);
                data.data?.globalFixers && this.remoteDataService.setGlobalFixersAddress(data.data.globalFixers);
                data.data?.fixers && this.remoteDataService.setFixersAddress(data.data.fixers);
                
                if (data.data?.storage) {
                    Object.entries(data.data?.storage)
                        .forEach(([name, data]) => this.storageService.updateMemoryStorage(name, data))
                    this.menuComponent.initByMessage();
                }
                
                this.isActive();
                this.sendLangScript();
                break;
            case "openMenu":
                this.menuComponent.initilizeMenu();
                this.globalService.setMobileDevice(data.view);
                this.menuDrawerComponent.initalizeDrawer();
                break;
            case "setMagnifyScale":
                this.storageService.set(StorageNames.MagnifyScale, data.data.scale);
                this.menuComponent.magnifyMenu();
                break;
            case "activateProfile":
                this.menuComponent.selectedMenuItems = data.data.profiles.reduce(
                    (profiles, profile) => ({...profiles, [profile]: true}),
                    {}
                );
                this.menuComponent.onApply();
                break;
            case "sendLog":
                this.sendLog(data.fullUrl, data.logMsg);
                break;
        }
    }
    
    async sendLangScript(){
        const langScript = await this.remoteDataService.getLangScript(this.globalService.fullUrl);
        const langScriptMessage = {
            action: "langScript",
            data: {langScript}
        }
        window.parent.postMessage(langScriptMessage, "*");
    }

    sendLog(url: string, logMsg: string) {
        (async () => await this.remoteDataService.sendLog(url, logMsg))();
    }

    isActive() {
        (async () => {
            let isActive = this.storageService.get(StorageNames.IsActive);
            let magnifyScale = this.storageService.get(StorageNames.MagnifyScale);
            const {
                validatorFixers,
                accessibilityFixers,
                globalFixers,
                mapping,
                localization
            } = await this.remoteDataService.getAll();
            if (isActive) {
                let settings = this.storageService.get(StorageNames.Settings);
                if (settings) {
                    let message = {
                        action: "settings",
                        data: {
                            localization,
                            settings: JSON.parse(unescape(settings)),
                            globalFixers,
                            accessibilityFixers,
                            validatorFixers,
                            mapping,
                            scale: magnifyScale
                        }
                    }
                    window.parent.postMessage(message, "*");
                }
            } else {
                window.parent.postMessage({action: "activateSnoozer"}, "*");
            }
        })()
    }


    onClick($event) {
        if ($event.keyCode === 27) {
            this.closeNav();
        }
    }

    closeNav() {
        let message: MessageModel = {
            action: "closeMenu",
        };
        this.globalService.postMessage(message);
    }

    menuItemsChanged($event) {
        this.menuItems = $event;
    }

    isRtl() {
        return this.globalService.isRtl();
    }

    isShowDrawer() {
        return !this.globalService.isMobile;
    }

    isLongLanguage(): boolean {
        return this.globalService.isLongLanguage();
    }

    isHideFooter() {
        if (
            this.globalService.settings &&
            this.globalService.settings.mainMenu &&
            this.globalService.settings.mainMenu.copyrightDisabled != undefined
        ) {
            return this.globalService.settings.mainMenu.copyrightDisabled;
        }

        return false;
    }
}
